export default __webpack_public_path__ + "static/media/080_finish_bad.hevc.46d5eab5.mp4";